import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IxellAPIService, Application, Roles } from '../../tools/api.service';
import { Utils } from '../../tools/utils';
import { Reference } from '../../tools/api.service';
import { ColorGroup } from 'src/app/entities/ColorGroup';
import { StorageService } from 'src/app/tools/storage.service';
import { Message } from '../../entities/message';
import { SearchCrit } from '../../entities/searchCrit';
import { SearchResult } from 'src/app/entities/searchResult';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
    selector: 'search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit, OnDestroy {
    @Input() colorCode: string;
    @Input() manufacturer: string
    @Input() technology: string;
    @Input() searchCrit: SearchCrit;
    @Output() listResult = new EventEmitter<SearchResult>();

    Utils = Utils;

    codeSearch: number;
    searchForm: UntypedFormGroup;
    colorList: ColorGroup[];
    applicationList: Application[];
    codeList: string[];
    designationList: string[];
    manufacturerList: string[];
    modelList: string[];
    vinres: Message;
    vinerror: string = "";
    expandVehicle: boolean = false;
    errorFord: boolean = false;
    role: Roles = Roles.Unknown;
    //selectedPaintLine: string = "ixell";

    private roleSub: any;
    private applicationSub: any;
    private colorSub: any;
    private referencesSub: any;
    private codeSub: any;
    private designationSub: any;
    private manufacturerSub: any;
    private modelSub: any;
    private VINSub: any;


    private timeLeft: number = 0;

    constructor(private headerService: HeaderService, private formBuilder: UntypedFormBuilder, private router: Router, private apiService: IxellAPIService, private storage: StorageService, private route: ActivatedRoute) {
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }
    ngOnInit() {

        ///*----------------------------------------------------------------------------------------------------*/console.log(this.route.snapshot.queryParams['tech']);
        var tech = this.technology ? this.technology : this.route.snapshot.queryParams['tech'];
        //if (tech) {
        //    this.selectedPaintLine = tech;
        //}

        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);

        window.onpopstate = function () {
        };
        let language = this.storage.get("actualLanguage");
        if (language == "" || language == null)
            language = "fr";
        this.applicationSub = this.apiService.getApplications(language).subscribe(data => {
            this.applicationList = data
            if (this.applicationSub != null) this.applicationSub.unsubscribe();
            this.colorSub = this.apiService.getColorGroup(language).subscribe(data => {
                this.colorList = data;
                if (this.colorSub != null) this.colorSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.colorSub != null) this.colorSub.unsubscribe();
                });
        },
            error => {
                console.log(error);
                if (this.applicationSub != null) this.applicationSub.unsubscribe();
            });

        if (this.colorCode == "null")
            this.colorCode = '';

        this.searchForm = this.formBuilder.group({
            colorCode: this.colorCode,
            designation: new UntypedFormControl(''),
            formuleNum: new UntypedFormControl(''),
            shadeGuideNum: new UntypedFormControl(''),
            colorGroup: new UntypedFormControl(''),
            manufacturer: this.manufacturer,
            model: new UntypedFormControl(''),
            year: new UntypedFormControl(''),
            application: new UntypedFormControl(''),
            codeSearch: new UntypedFormControl(2),
            designationSearch: new UntypedFormControl(2),
            vin: new UntypedFormControl(''),
            searchWorld: new UntypedFormControl(false),
            technology: new UntypedFormControl('')
        });

        if (this.colorCode != null && this.colorCode != "") {
            this.colorCode = null;
            this.codeSearch = 2;
            if (this.manufacturer != null && this.manufacturer != "")
                this.manufacturer = null;
            this.search();
        }

        if (this.searchCrit) {
            this.searchForm.setValue({
                colorCode: this.searchCrit.colorCode,
                designation: this.searchCrit.designation,
                designationSearch: 0,
                formuleNum: this.searchCrit.formuleNum,
                shadeGuideNum: this.searchCrit.shadeGuideNum,
                colorGroup: this.searchCrit.colorGroup,
                manufacturer: this.searchCrit.manufacturer,
                model: this.searchCrit.model,
                year: this.searchCrit.year,
                application: this.searchCrit.application,
                codeSearch: 2,
                vin: this.searchCrit.VIN,
                searchWorld: this.searchCrit.searchWorld,
                technology: this.searchCrit.technology
            });

            if (this.searchCrit.manufacturer != "" || this.searchCrit.application != "") {
                if (this.searchCrit.manufacturer != "")
                    this.getModels();
                this.expandVehicle = true;
            }
            else
                this.expandVehicle = false;
        }
        else {
            this.searchForm.setValue({
                colorCode: "",
                designation: "",
                designationSearch: 0,
                formuleNum: "",
                shadeGuideNum: "",
                colorGroup: "",
                manufacturer: "",
                model: "",
                year: "",
                application: "",
                codeSearch: 2,
                vin: "",
                searchWorld: false,
                technology: tech ? tech : "ixell"
            });
        }
    }

    ngOnDestroy(): void {
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.applicationSub != null) this.applicationSub.unsubscribe();
        if (this.colorSub != null) this.colorSub.unsubscribe();
        if (this.referencesSub != null) this.referencesSub.unsubscribe();
        if (this.designationSub != null) this.designationSub.unsubscribe();
        if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
        if (this.modelSub != null) this.modelSub.unsubscribe();
        if (this.VINSub != null) this.VINSub.unsubscribe();
    }

    search() {
        document.getElementById("errorlbl").style.visibility = "hidden";
        if (this.searchForm.value.application == "0") this.searchForm.value.application = "";
        if (this.searchForm.value.colorGroup == "0") this.searchForm.value.colorGroup = "";
        if (this.searchForm.value.colorCode == null) this.searchForm.value.colorCode = "";
        if (this.searchForm.value.formuleNum == null) this.searchForm.value.formuleNum = "";
        if (this.searchForm.value.shadeGuideNum == null) this.searchForm.value.shadeGuideNum = "";
        if (this.searchForm.value.year == null) this.searchForm.value.year = "";

        if (this.searchForm.value.colorCode != "" || this.searchForm.value.designation != "" || this.searchForm.value.formuleNum != "" || this.searchForm.value.shadeGuideNum != "" || this.searchForm.value.colorGroup != "" || this.searchForm.value.manufacturer != "" || this.searchForm.value.model != "" || this.searchForm.value.year != "" || this.searchForm.value.application != "") {
            this.searchCrit = {
                colorCode: this.searchForm.value.colorCode,
                designation: this.searchForm.value.designation,
                formuleNum: this.searchForm.value.formuleNum,
                shadeGuideNum: this.searchForm.value.shadeGuideNum,
                colorGroup: this.searchForm.value.colorGroup,
                manufacturer: this.searchForm.value.manufacturer,
                VIN: this.searchForm.value.vin,
                model: this.searchForm.value.model,
                year: this.searchForm.value.year,
                application: this.searchForm.value.application,
                searchWorld: this.searchForm.value.searchWorld,
                technology: this.searchForm.value.technology
            };
            this.colorCode = null;
            this.referencesSub = this.apiService.getReferences(this.searchForm.value.colorCode, this.searchForm.value.designation, this.searchForm.value.formuleNum, this.searchForm.value.shadeGuideNum, this.searchForm.value.colorGroup, this.searchForm.value.manufacturer, this.searchForm.value.model, this.searchForm.value.year, this.searchForm.value.application, this.codeSearch > 0 ? this.codeSearch : this.searchForm.value.codeSearch, this.searchForm.value.designationSearch, this.searchForm.value.searchWorld, this.searchForm.value.technology).subscribe(data => {
                let result: SearchResult = new SearchResult();
                result.crit = this.searchCrit;
                result.ref = data;
                if (data.length > 0) {
                    this.listResult.emit(result);
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.referencesSub != null) this.referencesSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.referencesSub != null) this.referencesSub.unsubscribe();
                });
        }
    }

    erase() {
        this.searchForm.setValue({
            colorCode: "",
            designation: "",
            designationSearch: 0,
            formuleNum: "",
            shadeGuideNum: "",
            colorGroup: "",
            manufacturer: "",
            model: "",
            year: "",
            application: "",
            codeSearch: 2,
            vin: "",
            searchWorld: false,
            technology: "ixell"
        });
    }

    changeManufacturer() {
        this.searchForm.setValue({
            colorCode: this.searchForm.value.colorCode,
            designation: this.searchForm.value.designation,
            designationSearch: this.searchForm.value.designationSearch,
            formuleNum: this.searchForm.value.formuleNum,
            shadeGuideNum: this.searchForm.value.shadeGuideNum,
            colorGroup: this.searchForm.value.colorGroup,
            manufacturer: this.searchForm.value.manufacturer,
            model: "",
            year: "",
            application: this.searchForm.value.application,
            codeSearch: this.searchForm.value.codeSearch,
            vin: this.searchForm.value.vin,
            searchWorld: this.searchForm.value.searchWorld
        });
    }

    selectModels() {
        this.searchForm.setValue({
            colorCode: this.searchForm.value.colorCode,
            designation: this.searchForm.value.designation,
            designationSearch: this.searchForm.value.designationSearch,
            formuleNum: this.searchForm.value.formuleNum,
            shadeGuideNum: this.searchForm.value.shadeGuideNum,
            colorGroup: this.searchForm.value.colorGroup,
            manufacturer: this.searchForm.value.manufacturer,
            model: this.searchForm.value.model,
            year: "",
            application: this.searchForm.value.application,
            codeSearch: this.searchForm.value.codeSearch,
            vin: this.searchForm.value.vin,
            searchWorld: this.searchForm.value.searchWorld
        });
    }

    selectCodes() {
        //let interval = setInterval(() => {
        //  if (this.timeLeft > 0) {
        //    this.timeLeft--;
        //  } else {
        if (this.searchForm.controls['colorCode'].value.length >= 2) {

            //this.timeLeft = 50;
            //clearInterval(interval);
            this.codeSub = this.apiService.getLstCode(this.searchForm.value.colorCode, this.searchForm.value.codeSearch, this.searchForm.value.searchWorld).subscribe(data => {
                this.codeList = data;
                if (this.codeSub != null) this.codeSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.codeSub != null) this.codeSub.unsubscribe();
                });
        }
        //  }
        //}, 500)
    }

    selectDesignations() {
        if (this.searchForm.value.designation.length >= 2) {
            this.designationSub = this.apiService.getLstDesignation(this.searchForm.value.designation, this.searchForm.value.designationSearch, this.searchForm.value.searchWorld).subscribe(data => {
                this.designationList = data;
                if (this.designationSub != null) this.designationSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.designationSub != null) this.designationSub.unsubscribe();
                });
        }
    }
    selectManufacturers() {
        if (this.searchForm.value.manufacturer.length >= 2) {
            this.modelSub = this.apiService.getLstModel(this.searchForm.value.manufacturer).subscribe(data => {
                this.modelList = data;
                if (this.modelSub != null) this.modelSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.modelSub != null) this.modelSub.unsubscribe();
                });

            this.manufacturerSub = this.apiService.getLstManufacturer(this.searchForm.value.manufacturer).subscribe(data => {
                this.manufacturerList = data;
                if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
                });
        }
        this.searchForm.controls["model"].setValue("");
        this.searchForm.controls["year"].setValue("");
        this.searchForm.controls["application"].setValue("");
    }

    getModels() {
        this.modelSub = this.apiService.getLstModel(this.searchForm.value.manufacturer).subscribe(data => {
            this.modelList = data;
            if (this.modelSub != null) this.modelSub.unsubscribe();
        },
            error => {
                console.log(error);
                if (this.modelSub != null) this.modelSub.unsubscribe();
            });
    }

    checkVin(event: any) {
        if (this.searchForm.value.vin.length == 17) {
            this.vinerror = "";
            this.errorFord = false;
            this.openLoader();
            this.VINSub = this.apiService.getLibelleTeinte(this.searchForm.value.vin).subscribe(data => {
                this.vinres = data;
                if (this.vinres.code > 0) {
                    this.searchForm.setValue({
                        colorCode: this.searchForm.value.colorCode,
                        designation: this.vinres.libelle,
                        designationSearch: this.searchForm.value.designationSearch,
                        formuleNum: this.searchForm.value.formuleNum,
                        shadeGuideNum: this.searchForm.value.shadeGuideNum,
                        colorGroup: this.searchForm.value.colorGroup,
                        manufacturer: this.searchForm.value.manufacturer,
                        model: this.searchForm.value.model,
                        year: this.searchForm.value.year,
                        application: this.searchForm.value.application,
                        codeSearch: this.searchForm.value.codeSearch,
                        vin: this.searchForm.value.vin,
                        searchWorld: this.searchForm.value.searchWorld
                    });
                }
                else {
                    this.vinerror = this.vinres.libelle;
                }
                if (this.VINSub != null) this.VINSub.unsubscribe();
                this.closeLoader();
            },
                error => {
                    this.errorFord = true;
                    console.log(error);
                    if (this.VINSub != null) this.VINSub.unsubscribe();
                    this.closeLoader();
                });
        }
    }

    openLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "flex";
        if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur();
    }

    closeLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "none";
    }

    launchMixitCloud(event: any) {
        if (event.value == "equinox") {
            //this.headerService.changeCanBack(false);
            this.headerService.changeTitle("Equinox");
            this.headerService.changeCanBack(false);
            this.router.navigate(["equinox"]);
        }

    }

}
